import type { ComponentProps } from "react";
import { classNames } from "../../utils/classNames";

export function InputRange(props: ComponentProps<"input">) {
  return (
    <input
      {...props}
      type="range"
      className={classNames(
        "w-full h-8 appearance-none bg-transparent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 disabled:opacity-50",

        // Track styles
        "[&::-webkit-slider-runnable-track]:bg-inverse-tertiary [&::-webkit-slider-runnable-track]:rounded-full [&::-webkit-slider-runnable-track]:h-1",
        "[&::-moz-range-track]:bg-inverse-tertiary [&::-moz-range-track]:rounded-full [&::-moz-range-track]:h-1",
        "[&::-ms-track]:bg-inverse-tertiary [&::-ms-track]:rounded-full [&::-ms-track]:h-1",

        // Thumb styles
        "[&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:bg-inverse-primary [&::-webkit-slider-thumb]:-mt-[14px] [&::-webkit-slider-thumb]:h-8 [&::-webkit-slider-thumb]:w-8 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:shadow-lg",
        "[&::-moz-range-thumb]:appearance-none [&::-moz-range-thumb]:bg-inverse-primary [&::-moz-range-thumb]:-mt-[14px] [&::-moz-range-thumb]:h-8 [&::-moz-range-thumb]:w-8 [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:shadow-lg",
        "[&::-ms-thumb]:appearance-none [&::-ms-thumb]:bg-inverse-primary [&::-ms-thumb]:-mt-[14px] [&::-ms-thumb]:h-8 [&::-ms-thumb]:w-8 [&::-ms-thumb]:rounded-full [&::-ms-thumb]:shadow-lg",

        props.className,
      )}
    />
  );
}
